import { render, staticRenderFns } from "./Newsdetails.vue?vue&type=template&id=c9a8254c&scoped=true&"
import script from "./Newsdetails.vue?vue&type=script&lang=js&"
export * from "./Newsdetails.vue?vue&type=script&lang=js&"
import style0 from "./Newsdetails.vue?vue&type=style&index=0&id=c9a8254c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a8254c",
  null
  
)

export default component.exports